import React, { useEffect, useContext } from 'react';
import { ChangeList } from './change/ChangeList';
import { Filter } from './Filter';
import { Webservice } from '../services/Webservice';
import { Store, StoreState } from './Store';
import { IconSpinner } from '../icons/icon';
import { ErrorResponse } from '../services/model';
import { Footer } from './Footer';
import { Header } from './Header';
import { ErrorElement } from './ErrorElement';
import { ChangeDetailList } from './change/ChangeDetailList';

export const Changes: React.FC = () => {
    const { isInternal, changes, error } = useContext(Store);

    useEffect(() => {
        Webservice.getChanges()
            .then((changesResponse) => {
                if (changesResponse)
                    StoreState.set({ isInternal: changesResponse.isInternal, changes: changesResponse.changes });
            })
            .catch((error: ErrorResponse) => {
                StoreState.set({ error: error });
            });
    }, []);

    if (error) {
        return <ErrorElement error={error} />;
    }

    if (!changes) {
        return (
            <main className="loading main-container">
                <IconSpinner className="big-spinner" />
            </main>
        );
    }

    return (
        <React.Fragment>
            <Header logoHref="/" isInternal={isInternal} />
            <main className="container main-container d-flex flex-column min-vh-100">
                <div className="flex-fill container">
                    <div className="main-table">
                        <ChangeList isInternal={isInternal ? isInternal : false} changes={changes} />
                    </div>
                    <Filter />
                    {changes.map((change, index) => (
                        <div className="container">
                            <h2 id={change.changeId} className="small-indent-left">
                                {change.description}
                            </h2>
                            <div className="small subheading small-indent-left">
                                Check out how to comply:{' '}
                                <a href={change.documentationReference}>{change.documentationReference}</a>
                            </div>
                            <div key={index} className="chip-container flex-fill container detail-table">
                                <ChangeDetailList changeScope={change.scope} changeDetails={change.changeDetails} />
                            </div>
                        </div>
                    ))}
                </div>
                <Footer />
            </main>
        </React.Fragment>
    );
};
